import { API_BASE } from '../variables/variablesConection';

// Consulta la cotizacion al backendCotizaciones (una sola llamada).
// Devuelve { cerrada, data } donde `data` mantiene el formato que ya consumen
// los componentes (arreglo de filas por linea con dtl/descuento/contacto).
export async function getCotizacionConsolidada(uuid) {
    const res = await fetch(`${API_BASE}/${encodeURIComponent(uuid)}`);

    // Cotizacion cerrada/caducada: el backend responde 410 y notifica al asesor.
    if (res.status === 410) {
        const info = await res.json().catch(() => ({}));
        return {
            cerrada: true,
            data: [{
                Cotizacion: info.cotizacion || uuid,
                Asesor: info.asesor || '',
                Telefono: info.telefono || '',
                Correo: info.correo || '',
                Cliente: info.cliente || '',
                estado: 'Completado',
            }],
        };
    }

    if (!res.ok) {
        throw new Error(`Error ${res.status} al consultar la cotizacion`);
    }

    const c = await res.json();

    const data = (c.lineas || []).map((l) => ({
        comentario: c.comentario,
        zona: c.zona,
        estado: c.estado,
        Fecha: c.fecha,
        fechavalides: c.fechaValidez,
        Producto: l.producto,
        Linea: l.linea,
        ProductoDescripcion: l.descripcion,
        Valor: l.valor,
        Cotizacion: c.cotizacion,
        Asesor: c.asesor ? c.asesor.nombre : '',
        AsesorID: c.asesor ? c.asesor.id : '',
        Cliente: c.cliente ? c.cliente.nombre : '',
        Telefono: c.cliente ? c.cliente.telefono : '',
        Correo: c.cliente ? c.cliente.correo : '',
        Residencia: c.cliente ? c.cliente.residencia : '',
        Pais: c.cliente ? c.cliente.pais : '',
        contacto: c.cliente ? c.cliente.contacto : '',
        Impuesto: l.impuesto,
        Cantidad: l.cantidad,
        Moneda: l.moneda,
        iva: l.iva,
        dtl: { valor: l.precioLista != null ? l.precioLista : 1, moneda: l.moneda || '' },
        descuento: { linea: l.linea, descuento: l.descuento || 0 },
        esMP: l.esMP || false,
        servicio: l.servicio || null,
    }));

    return { cerrada: false, data };
}

// Registra la aceptacion/rechazo del tratamiento de datos personales.
export async function registrarAceptacion(uuid, decision) {
    try {
        await fetch(`${API_BASE}/${encodeURIComponent(uuid)}/aceptacion`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ decision }),
        });
    } catch (error) {
        console.error('No se pudo registrar la aceptacion:', error);
    }
}
